import React from 'react'
import { Title, Description } from './ProfileModal.styles'
import {
  ContentContainer,
  Form,
  InlineFormRow,
  Separator,
} from './ProfileDetailsStep.styles'
import { FormikProps } from 'formik'
import { Input, WorkspaceLogo, TextAreaWithCharCount } from '@sketch/components'
import { WorkspaceMinimalFragment } from '@sketch/gql-types'
import { WorkspaceProfileURL } from '../../containers/WorkspaceProfileURL'
import { initialValues } from './form'

interface ProfileDetailsStepProps {
  workspace: WorkspaceMinimalFragment
  formikBag: FormikProps<typeof initialValues>
}

export const ProfileDetailsStep = ({
  workspace,
  formikBag,
}: ProfileDetailsStepProps) => {
  const { values, errors, touched, handleChange, handleBlur, setFieldValue } =
    formikBag

  const workspaceLogoSrc = workspace.avatar?.small

  // It can happen that the values are not available yet
  if (!values) return null

  const handleProfileURLChange = (value: string) => {
    setFieldValue('profileUrl', value)
  }

  return (
    <>
      <ContentContainer>
        <Title>Page Details</Title>
        <Description>
          This is the information people will see on your Public Profile, make
          it yours.
        </Description>
      </ContentContainer>

      <Separator />

      <ContentContainer>
        <Form>
          <InlineFormRow>
            <WorkspaceLogo
              size="64px"
              workspaceName={workspace?.name}
              src={workspaceLogoSrc}
            />
            <Form.Field mb={0} name="text" label="Name">
              <Input name="name" type="text" value={workspace?.name} readOnly />
            </Form.Field>
          </InlineFormRow>
          <WorkspaceProfileURL.Root
            shortUrl={values?.shortUrlName}
            name="shortUrlName"
            formikBag={formikBag}
          >
            {profileUrlMutationProps => {
              const { isUrlAvailable } = profileUrlMutationProps
              return (
                <div>
                  <WorkspaceProfileURL.Input
                    label={<>Public URL</>}
                    name="shortUrlName"
                    formikBag={formikBag}
                    profileShortURLProps={profileUrlMutationProps}
                    onChange={handleProfileURLChange}
                  />
                  <WorkspaceProfileURL.Error
                    name="shortUrlName"
                    formikBag={formikBag}
                    isUrlAvailable={isUrlAvailable}
                  />
                </div>
              )
            }}
          </WorkspaceProfileURL.Root>
          <Form.Field
            mb={0}
            name="description"
            label="Description (optional)"
            errorText={touched.description ? errors.description : undefined}
          >
            <TextAreaWithCharCount
              name="description"
              value={values.description}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="What tickles you, as a designer?"
              $minHeight="100px"
              $maxHeight="200px"
              $resize="vertical"
              maxLength={250}
            />
          </Form.Field>
          <Form.Field
            mb={0}
            name="text"
            label="Link (optional)"
            errorText={touched.websiteUrl ? errors.websiteUrl : undefined}
          >
            <Input
              name="websiteUrl"
              type="text"
              value={values.websiteUrl}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="https://mywebsite.com"
            />
          </Form.Field>
        </Form>
      </ContentContainer>
    </>
  )
}
